let audioContext;
const SOUND_KEY = 'muulti-unlock-sound';
export const SOUND_EVENT = 'muulti-unlock-sound-change';
let soundEnabled = true;
export function getUnlockSoundEnabled() {
    try { return localStorage.getItem(SOUND_KEY) !== 'off'; } catch { return soundEnabled; }
}
export function setUnlockSoundEnabled(enabled) {
    soundEnabled = enabled;
    try { localStorage.setItem(SOUND_KEY, enabled ? 'on' : 'off'); } catch { /* Optional preference. */ }
    window.dispatchEvent(new Event(SOUND_EVENT));
}
export function prefersReducedMotion() {
    return !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}
export function playUnlockChime() {
    if (!getUnlockSoundEnabled()) return;
    try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        if (!audioContext || audioContext.state === 'closed') audioContext = new AudioContext();
        if (audioContext.state === 'suspended') audioContext.resume()?.catch(() => {});
        [523.25, 659.25, 783.99].forEach((frequency, index) => {
            const oscillator = audioContext.createOscillator();
            const gain = audioContext.createGain();
            const start = audioContext.currentTime + index * 0.065;
            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(frequency, start);
            gain.gain.setValueAtTime(0, start);
            gain.gain.linearRampToValueAtTime(0.035, start + 0.015);
            gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.85);
            oscillator.connect(gain);
            gain.connect(audioContext.destination);
            oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
            oscillator.start(start);
            oscillator.stop(start + 0.9);
        });
    } catch { /* A celebration must never prevent revealing content. */ }
}
